<div class="gather-viewer" #container>
  @if (plotRect(); as rect) {
    <div
      class="plot-area"
      [class.zoomed]="isZoomed()"
      [class.pan-tool]="isZoomed() && panTool()"
      [class.panning]="panning()"
      [style.left.px]="rect.left"
      [style.top.px]="rect.top"
      [style.width.px]="rect.width"
      [style.height.px]="rect.height"
      (mousedown)="onPointerDown($event)"
      (mousemove)="onPointerMove($event)"
      (mouseup)="onPointerUp($event)"
      (mouseleave)="onPointerLeave()"
      (wheel)="onWheel($event)"
    >
      @if (drawsSamples()) {
        <!-- cells / wiggles, drawn from the samples at screen resolution -->
        <canvas
          #canvas
          [style.width.px]="rect.width"
          [style.height.px]="rect.height"
        ></canvas>
        @if (!samples() && !loading()) {
          <div class="plot-placeholder">No samples loaded</div>
        }
      } @else if (imageSrc(); as src) {
        @if (imageBox(); as box) {
          <img
            [src]="src"
            alt="Shot gather"
            draggable="false"
            [style.left.px]="box.left"
            [style.top.px]="box.top"
            [style.width.px]="box.width"
            [style.height.px]="box.height"
          />
        }
      } @else if (!loading()) {
        <div class="plot-placeholder">No gather loaded</div>
      }

      @if (selectionRect(); as sel) {
        <div
          class="zoom-rect"
          [style.left.px]="sel.left"
          [style.top.px]="sel.top"
          [style.width.px]="sel.width"
          [style.height.px]="sel.height"
        ></div>
      }
    </div>
  }

  <!-- D3 axes + selected-trace marker are drawn into this svg -->
  <svg #axes class="axes-svg"></svg>
  <!-- hover readout over the header tracks -->
  <svg #overlay class="axes-svg"></svg>

  @if (isZoomed()) {
    <div
      class="zoom-controls omit-from-screenshot"
      [style.top.px]="tracksHeight() + 28"
    >
      <nz-button-group nzSize="small">
        <button
          nz-button
          nz-tooltip
          nzTooltipTitle="Back to the previous zoom"
          (click)="zoomBack()"
        >
          <span nz-icon nzType="rollback"></span>
          Back
        </button>
        <button
          nz-button
          nz-tooltip
          nzTooltipTitle="Reset zoom (full gather)"
          (click)="resetZoom()"
        >
          <span nz-icon nzType="fullscreen-exit"></span>
        </button>
        <button
          nz-button
          nz-tooltip
          nzTooltipTitle="Pan: drag to move the view. Also Shift-drag, middle-drag, or scroll / two-finger swipe; pinch or Ctrl/⌘-scroll to zoom"
          [nzType]="panTool() ? 'primary' : 'default'"
          (click)="panTool.set(!panTool())"
        >
          <span nz-icon nzType="drag"></span>
        </button>
      </nz-button-group>
    </div>
  }

  @if (meta(); as m) {
    <div class="meta-caption">
      @if (sampleNote(); as note) {
        <span class="sample-note">{{ note }} &middot;</span>
      }
      {{ m.n_traces }} traces &middot; clip {{ formatAmp(m.clip_value) }}
      &middot; vmin {{ formatAmp(m.vmin) }} &middot; vmax
      {{ formatAmp(m.vmax) }}
    </div>
  }

  @if (loading()) {
    <div class="loading-overlay">
      <nz-spin nzSize="large"></nz-spin>
    </div>
  }
</div>
